export const errorText = (err) =>
  err?.message || err?.description || String(err || 'unknown error');

// What the agent sees. The SDK's message and code are the only thing that
// distinguishes "no microphone" from "token expired" from "number blocked".
export const dialFailureMessage = (err) => {
  const code = err?.code;
  const text = errorText(err);
  return code ? `Failed to place call: ${text} (Twilio ${code})` : `Failed to place call: ${text}`;
};

export const ENDED_BEFORE_ANSWER_LABEL = 'Busy / unreachable';

// With answerOnBridge, a busy / declined / fast-failing callee makes Twilio
// hang up the agent leg before accept, which the SDK reports as 31005 from
// the gateway. That is a call outcome, not a fault on our side.
const isEndedBeforeAnswer = (err, ringing) => {
  if (String(err?.code ?? '') !== '31005') return false;
  if (ringing) return true;
  return /HANGUP/i.test(`${err?.message || ''} ${err?.description || ''}`);
};

// For errors raised on the call before 'accept'. An outcome carries a pill
// label; a genuine failure carries a message for the agent instead.
export const classifyPreAcceptError = (err, { ringing = false } = {}) => {
  if (isEndedBeforeAnswer(err, ringing)) {
    return {
      reason: 'outbound_ended_before_answer',
      status: 'ended',
      label: ENDED_BEFORE_ANSWER_LABEL
    };
  }
  return {
    reason: 'outbound_connect_failed',
    status: 'failed',
    message: dialFailureMessage(err)
  };
};
